import { useUpdateURLSearchParams } from "@/hooks/useQuery";
import Modal from "@/ui/Modal";

import { AddNewCustomFieldsForm } from "../CustomFieldsForm/AddNewCustomFieldsForm";

export const AddNewCustomFieldsModal = () => {
  const updateParams = useUpdateURLSearchParams();

  return (
    <Modal
      open
      footer={() => undefined}
      onCancel={() => updateParams(["addNew", undefined])}
      title="Create Custom Field"
    >
      <AddNewCustomFieldsForm />
    </Modal>
  );
};
